import axios from 'axios';
import { createSignedPostRequest } from 'utils/createSignedRequestsHelpers';

export const postCreatePrivateProjectBankFolder = async (
  projectId,
  newFolderAttributes
) => {
  const apiPath = `project-bank/private/project/${projectId}/create-folder`;

  const signedRequest = await createSignedPostRequest({
    apiPath,
    body: { folderAttributes: newFolderAttributes },
  });

  const response = await axios(signedRequest);

  return response.data;
};
